import { render, staticRenderFns } from "./drag_image.vue?vue&type=template&id=73be70fc&scoped=true&"
import script from "./drag_image.vue?vue&type=script&lang=js&"
export * from "./drag_image.vue?vue&type=script&lang=js&"
import style0 from "./drag_image.vue?vue&type=style&index=0&id=73be70fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73be70fc",
  null
  
)

export default component.exports